import { render, staticRenderFns } from "./GiftcardRelations.vue?vue&type=template&id=af199d70&"
import script from "./GiftcardRelations.vue?vue&type=script&lang=js&"
export * from "./GiftcardRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports